import { useQuery } from '@tanstack/react-query'
import { bomCapturaApi } from '@/services/api'

/** Versiones (formula + empresa) de un artículo. */
export function useVersiones(itemId: string) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['bom-versiones', itemId],
    queryFn: () => bomCapturaApi.getVersiones(itemId),
    enabled: Boolean(itemId),
    staleTime: 5 * 60 * 1000,
  })
  return { versiones: data?.data ?? [], isLoading, isError }
}
